// extracted by mini-css-extract-plugin
module.exports = {"banner":"AuthBanner_banner__yLbHu","bannerImg":"AuthBanner_bannerImg__rIB4G"};